import Map from './routes/Map'
import Login from './routes/login/Login'
import Logout from './routes/logout/Logout'
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {LANDING, LOGIN, MAP} from './constants/routes'
import NavigationBar from "./routes/Navigation";
import PortfolioList from "./routes/portfolios/PortfolioList";
import ChangePassword from "./routes/account/ChangePassword";
import {AuthProvider} from "./context/authContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import UserProfile from "./routes/account/Profile";
import PasswordReset from "./routes/account/PasswordReset";
import PasswordResetDone from "./routes/account/PasswordResetDone";
import React, { useEffect } from 'react';

function App() {
    const [selectedProject, setSelectedProject] = React.useState(localStorage.getItem("project"));

    useEffect(() => {
        localStorage.setItem("project", selectedProject);
    }, [selectedProject]);

    return (
        <BrowserRouter>
            <AuthProvider>
                <NavigationBar selectedProject={selectedProject} setSelectedProject={setSelectedProject}/>
                <Routes>
                    <Route index path={LANDING} element={<Login/>}/>
                    <Route path="/index" element={<ProtectedRoute redirectPath={LOGIN}><Map project={selectedProject}/></ProtectedRoute>}/>
                    <Route path={MAP} element={<ProtectedRoute redirectPath={LOGIN}><Map
                        project={selectedProject}/></ProtectedRoute>}/>
                    <Route path="/projects" element={<ProtectedRoute redirectPath={LOGIN}><PortfolioList
                        selectedProject={selectedProject}/></ProtectedRoute>}/>

                    <Route path={LOGIN} element={<Login/>}/>
                    <Route path="/logout" element={<Logout/>}/>
                    <Route path="/account/password_reset" element={<PasswordReset/>}/>
                    <Route path="/account/password_reset/done" element={<PasswordResetDone/>}/>
                    <Route path="/account/password"
                           element={<ProtectedRoute redirectPath={LOGIN}><ChangePassword/></ProtectedRoute>}/>
                    <Route path="/account/profile"
                           element={<ProtectedRoute redirectPath={LOGIN}><UserProfile/></ProtectedRoute>}/>
                    <Route path="/account"
                           element={<ProtectedRoute redirectPath={LOGIN}><UserProfile/></ProtectedRoute>}/>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App